export enum MapLayers {
  TRAFFIC_LAYER = "Traffic Layer",
  CAMERA_LAYER = "Traffic Cameras",
  DISPATCH_EVENTS = "Dispatch Events",
  ASSOC_DISPATCH_EVENTS = "Associated Dispatch Events",
  VCC_INCIDENTS = "VCC Incidents",
  CURRENT_INC = "Current VCC Incident",
  ALL_ANNOTATIONS = "Incident Map Annotations",
  ANNOTATIONS_PERIMETER = "ANNOTATIONS_PERIMETER",
  ANNOTATIONS_DETOUR = "ANNOTATIONS_DETOUR",
  ANNOTATIONS_BLOCKAGE = "ANNOTATIONS_BLOCKAGE",
  CONSTRUCTION_EVENTS_DATA = "Construction Events",
  MAJOR_EVENTS = "Major Events",
}

export enum MapIcons {
  CAMERA = "Camera",
  CONSTRUCTION_EVENT = "Construction Event",
  MAJOR_CONSTRUCTION_DATA = "Major Construction Events",
  MAJOR_EVENTS_SPECIAL = "Major Events Special",
  MAJOR_EVENTS_CONSTRUCTION = "Major Events Construction",
}

export enum MarkerTypes {
  DISPATCH = "DISPATCH",
  INCIDENT = "INCIDENT",
  ASSOC_DISPATCH = "ASSOC_DISPATCH",
  CURRENT_INC = "CURRENT_INC",
}

export enum DrawTypes {
  PERIMETER = "Perimeter",
  DETOUR = "Detour",
  BLOCKAGE = "Blockage",
}
